import { projectTourOntourSlice } from '../project-tour-ontour.slice';

export const clearTourEvents = projectTourOntourSlice.actions.clearTourEvents;
